module.exports = __webpack_public_path__ + "static/media/paper.c7122ed3.svg";